<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202402_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202402_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right"><span>エイジングサイン気付いてる？</span><br>「ヒアルロン酸」を<br>味方につける</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">あなたは自分の肌の<br>「エイジングサイン」<br>気がついていますか？</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202402_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">肌年齢は自分次第</h3>
        <p class="mb-3">年齢を重ねるにつれて、多くの方が気になるのはお肌のお悩み。</p>
        <p class="mb-3">シミやシワなど、改善させたいと思う肌年齢の悩みは増える一方で、ついお手入れをサボってしまったり、諦めてしまっている部分はありませんか？</p>
        <p class="mb-3">お肌は正しいスキンケアや健康的な生活で、改善できる見込みは十分にあります。</p>
        <p class="mb-3">自分の肌のお悩みに合わせたエイジングケアアイテムを知ること。</p>
        <p class="mb-3">そのためにはお肌の「エイジングサイン」を見逃さないことがとても大切です。</p>
        <p class="mb-3">みなさんの年齢肌による悩みを改善できる一歩のために。</p>
        <p>そこで今回は「自分だけじゃない！多くの方が抱える肌年齢の悩みと重要ポイントとは？」をテーマに深掘りしていきましょう。</p>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5 mb-3">いつ「エイジングサイン」に気がついた？<br>みなさんの肌年齢サインの意識を調査</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">今回は30代～50代の一般女性を対象に、</p>
      <p class="mb-3">「エイジングサインとスキンケア」に関する調査を実施。</p>
      <p>一般女性のお肌の老化「エイジングサイン」に対する意識と、重要とするポイントについて見ていきましょう。</p>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">エイジングサインに気が付いたのはいつ？どのパーツ？<br>多くの方が30歳から、"ほうれい線"と回答</h3>
        <p class="mb-3">はじめに、30代～50代の女性に、エイジングケアのサインについて調査。</p>
        <p class="mb-3"><strong>「エイジングサインに気がついたのはいつ頃ですか？」</strong></p>
        <p class="mb-3">6割以上の方が30歳～44歳までにエイジングサインに気がついたようです。</p>
        <p>そしてそのサインは『ほうれい線』『目元、目尻』から気が付いたとの回答が半数を占め、このパーツはスキンケアを注力すべきポイントであることもうかがえます。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202402_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202402_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">気になるエイジングサインとは？</h3>
        <p class="mb-3"><strong>「どういったエイジングサインがありましたか？（複数回答可）」</strong></p>
        <p class="mb-3">『しわ（65.1%）』<br>『たるみ（51.6%）』<br>『しみ（44.9%）』</p>
        <p class="mb-3">みなさんに、どんな肌悩みのエイジングサインがあったのかを聞きました。</p>
        <p class="mb-3">「しわ」「たるみ」「しみ」はやはり気になる部分のよう。</p>
        <p>スキンケアで大切なことはまずは原因となる要因を知り、予防と対策のケアを正しく行うことです。</p>
      </div>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">エイジングサインに気づいて、スキンケアを変更した女性は半数以上に。そのスキンケア方法とは？</h3>
        <p class="mb-3">では、エイジングサインに気づいてスキンケア方法を変えた方はどのくらいいるのでしょうか？</p>
        <p class="mb-3">なんと約半数の方が「エイジングサインに気づいた後、スキンケア方法を変えた」とのこと。</p>
        <p class="mb-3">そしてその変えた「スキンケア方法」とは・・？</p>
        <p class="mb-3"><strong>『エイジングケアアイテムの使用（59.2%）』<br>『保湿の強化（54.8%）』<br>『フェイスマスク・パック（33.8％）』</strong></p>
        <p>6割近くの方が、今までのスキンケアに「エイジングケアアイテム」を加えて、アンチエイジングへのアプローチケアを始める方が多いようです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202402_05.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202402_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">スキンケアを変えたことによる効果は？<br>多くの女性が【潤い】を実感！</h3>
        <p class="mb-3">続いて、スキンケア方法を変えたことによって、肌はどのように変化したのかうかがいました。</p>
        <p class="mb-3">『変化は実感していない』と回答した方が多い一方で、『潤いを感じられるようになった』と感じる方も多いようです。</p>
        <p class="mb-3">次に、変化があった方にどのような変化があったか具体的に聞いてみました。</p>
        <p class="mb-3"><strong>「スキンケア方法を変えて感じた肌の変化を教えてください」</strong></p>
        <p class="mb-3">・肌荒れが減って、顔色がくすみ気味だったけどトーンアップしてハリが出た（30代）</p>
        <p class="mb-3">・目尻に乾燥を感じていたのが、エイジングを意識した基礎化粧品とフェイシャルエステを導入することにより、肌が明るくふっくらしたように感じた（40代）</p>
        <p class="mb-3">・夜のスキンケアを怠ると、すぐにおでこにシワがはいっていたが、できなくなってきた（40代）</p>
        <p class="mb-3">・深いしわが、薄くなった（50代）</p>
        <p><strong>スキンケア方法を変えたことで、肌荒れが減ったり、深いしわが薄くなったりと変化を感じた方がいるようです。</strong></p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">スキンケアで重視したい成分は？<br>第1位は【ヒアルロン酸】</h3>
        <p class="mb-3">スキンケア方法を変えて、お肌の変化を実感する方も多いことは明らかのようです。</p>
        <p class="mb-3">では、スキンケアをする際に皆さんはどのような成分を重視しているのでしょうか？</p>
        <p class="mb-3"><strong>『ヒアルロン酸（61.7％）』<br>『ビタミンC（45.9％）』<br>『セラミド（28.3％）』</strong></p>
        <p>6割以上の方が<strong>『ヒアルロン酸』</strong>と回答したことから、エイジングケアには<strong>ヒアルロン酸</strong>が重要だと思っている方が多いことが判明しました。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202402_07.jpg">
      </div>
    </div>

    <div class="mb-5 pb-5">
      <p class="mb-3">続いて、『ヒアルロン酸』と回答した方に、エイジングケアにおいてなぜ重要と考えるかについて、具体的な理由を聞いてみました。</p>
      <p class="mb-3"><strong>■ヒアルロン酸を重視する理由を教えて！</strong><br>・水分とハリをもたせたいから（40代）<br>・ハリが欲しい（40代）<br>・シワ予防やシミ、肌のハリに良さそうなので（50代）<br>・エイジングケアに有効的な成分としてよく見るものなので（50代）</p>
      <p class="mb-3">ヒアルロン酸の成分に、肌のハリを期待している方が多いようです。</p>
      <p class="mb-3">最後に、<strong>エイジングスキンケア製品にどのような効果</strong>を期待しているか聞いてみました。</p>
      <p class="mb-3">「エイジングスキンケア製品にどのような効果を期待しますか？（複数回答可）」と質問したところ、</p>
      <p class="mb-3"><strong>『しわの改善（63.7％）』<br>『ハリ・ツヤ効果（55.7％）』<br>『潤い効果（42.6％）』</strong><br>と続きました。</p>
      <p>6割以上の方が『しわの改善』と回答したことから、しわがあることで年齢を感じやすいと思っている方が多いのかもしれません。</p>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_image w-25">
        <img src="@/assets/img/column/202402_08.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-75 text-center">
        <h3 class="mb-3">エイジングケアのアイテム選びは<br>ヒアルロン酸を重視している！</h3>
        <p class="mb-3">今回の調査では30代を超えたあたりから、ほうれい線や目元・目尻のしわといった<br>エイジングサインを感じた方が多いことが明らかになりました。</p>
        <p class="mb-3">そして、6割以上の方がエイジングケアアイテムには、しわの改善を期待しているようです。</p>
        <p class="mb-3">エンジングスキンケアの中でも重要視している成分は、ヒアルロン酸が最も関心を集めています。</p>
        <p>しわ改善を求める方が多い中で、ヒアルロン酸は人気な成分のようです。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3">重要なのは、肌悩みにあわせたエイジングスキンケア製品を選ぶこと。</p>
        <p class="mb-3">迷った際はヒアルロン酸を意識してみてはいかがでしょうか？</p>
        <p>スペシャルケアでキメの整った上質なハリ肌へ！</p>
      </div>
    </div>
   
    <div class="layer_02 pt-5">
      <img src="@/assets/img/column/202402_09.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>理想の美しさを求めるスペシャルケア</span><br>SPECIALシリーズ</h2>
          <p class="mb-3">理想の美しさは、一人ひとり違います。</p>
          <p class="mb-3">ピンとしたハリ肌。透明感にあふれた肌。</p>
          <p class="mb-3">乾燥による小ジワの目立たない肌。</p>
          <p class="mb-3">あるいは、年齢を感じさせない、<br>輝きに満ちた表情かもしれません。</p>
          <p class="mb-3">思い描くその肌、その表情へ導くアイテム。</p>
          <p class="mb-3">ベーシックケアだけでは足りないものを補うアイテム。</p>
          <p>ゆっくりと鏡に向かい、そっと肌にふれて、<br>まずは、特別な一品を選んでみてください。</p>
        </div>
      </div>
    </div>

    <h2 class="mt-5 pt-5 mb-3">ずっと素肌でいたいから。</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">基本の日々のケアに立ち返り、明日も自分の肌を好きでいるために。</p>
      <p>あなたらしい毎日をあなたのペースで取り入れてみてほしい。</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">SPECIAL<br>マナビス リフトセラム</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">4種の「ヒアルロン酸」を贅沢に配合。</p>
        <p class="mb-3">更に数種の美容成分も配合し、<br>なじんだ後にピンとした上質なハリを感じます。</p>
        <p>肌にすうっとなじみ、キメを整えるスペシャルな美容液。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_liftserum_202402.jpg">
      </div>
    </div>

    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">ベタつかずトロッとしたテクスチャー。無色透明で爽やかにほんのり香ります。</p>
        <p>皮膚にベールが掛かったような安心感。浸透もよくて気持ちのいい美容液です。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">ヒアルロン酸が4種類も入っていて「贅沢な美容液」というのはその通り。</p>
        <p>肌にスーッと浸透し、しっとりピーンという肌感です。とても使用感がよく、値段通りいい商品だと思います。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">濃厚な感じがあり、肌がとても潤います。</p>
        <p>保湿クリームを使わなくても、長い時間保湿が維持されているので、ナイトケアをした翌日の朝は、もっちりぷにぷになお肌のまま！</p>
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_creamf_202402.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">SPECIAL<br>マナビス クリーム F</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">乾燥による小ジワの目立たない*、うるおいと輝きに満ちた肌へ。</p>
        <p class="mb-3">フラーレン配合のエイジングケアクリーム。</p>
        <p>さらに、植物由来保湿成分もたっぷり配合したリッチなクリーム。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>

    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p>保湿力が高く、持続するので嬉しい。化粧のりも良くなるし、乾燥を防げていると感じます。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p class="mb-3">しっとり濃密で凄く良い。</p>
        <p>これを塗ると、シワも薄くなるような実感を感じています。とても気に入りました。</p>
      </div>
      <div class="feature-row_voice_item">
        <div class="icon">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-tcwi-chat" viewBox="0 0 100 100"><defs></defs><path class="a" d="M88.78 28.25v47.18h-9.42v10.58L62.91 75.43H32.55V28.25h56.23zM41.85 42.53h37.51M41.85 51.83h37.51M41.85 61.14h26.58"></path><path class="a" d="M67.45 13.99v14.26h-34.9v35.83l-11.91 7.67V61.16h-9.42V13.99h56.23z"></path></svg>
        </div>
        <h3>お客様の声</h3>
        <p>エイジングケア、抗酸化力があると言われるフラーレン成分が入っていて、更にフラーレンロゴマークが表記されてありましたので、安心して使用出来ました。</p>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">その他BASICラインの商品</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_whiteningessence_202402.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用ホワイトニングエッセンスEX</div>
          <p>なめらかで透明感のある肌へ。<br>しっとりとなじむ美白美容液。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_bihakulotion_202402.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用美白ローション</div>
          <p>紫外線やブルーライトによる乾燥から守り、<br>肌あれを防ぐ、集中ケア化粧水。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_moisturegel_202402.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">モイスチャージェル</div>
          <p>乾燥による小ジワの目立たない肌へ。<br>バリア機能を助けるジェル状保湿液。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000005.000124389.html" target="_blank" title="マナビス化粧品。【ほうれい線や目元のしわがエイジングサイン？】6割以上がスキンケアで重視する成分として「ヒアルロン酸」と回答する結果に">【ほうれい線や目元のしわがエイジングサイン？】6割以上がスキンケアで重視する成分として「ヒアルロン酸」と回答する結果に</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「エイジングサインとスキンケア」に関する調査<br>
        【調査期間】2023年12月14日（木） ～ 2023年12月15日（金）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「PRIZMA」によるインターネット調査<br>
        【調査人数】1,005人<br>
        【調査対象】調査回答時に30～50代女性と回答したモニター<br>
        【モニター提供元】ゼネラルリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 400px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  bottom: 10%;
  right: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: baseline;
      background-image: url('../../assets/img/column/202402_09.jpg');
      background-size: cover;
      min-height: 750px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
      justify-content: end;
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 52%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>